import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { axiosClient } from '../axios';
import { usePromise } from './usePromise';

export const useAxiosRequest = <T, U = never>(config: AxiosRequestConfig<U>) =>
  usePromise<AxiosResponse<T, U>>(() => axiosClient.request<T>(config));
